import React from 'react';
import Details from '@stone/components/details/Details';
const RailDetails = (props) => {
    var _a, _b, _c;
    const { regions, counter, content, title } = props;
    const mappedProps = {
        title,
        content,
        showCounter: counter,
        accordion: (_a = regions === null || regions === void 0 ? void 0 : regions.accordion) === null || _a === void 0 ? void 0 : _a.components,
        type: !((_c = (_b = regions === null || regions === void 0 ? void 0 : regions.accordion) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c.length) ? 'content' : 'accordion',
    };
    return React.createElement(Details, Object.assign({}, mappedProps));
};
export default RailDetails;
